<div #container></div>

<input type="file" accept=".jpg,jpeg,.png" (change)="fileSelected($event.target.files)" />
